// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SmartTextareaInput":"bfs_a bhb_tx bhb_ul bhb_wa bhb_uc"};